import { useState } from 'react';
import './App.css';
import CompInput from './component/CompInput';
import CompPrev from './component/CompPrev';
import axios from 'axios';

function App() {
  const [valbarcode, setvalbarcode] = useState();
  const [products, setProducts] = useState([]);
  const [loadupdate, setloadupdate] = useState(false);
  const [loadresponse, setloadresponse] = useState('');

  const preview = () => {
    const values = valbarcode.split('\n');
    const trimmedValues = values.map((value) => value.trim());
    const nonEmptyValues = trimmedValues.filter((value) => value !== '');
    axios
      .post('https://warehouseapi.sidehustle.id/preview', nonEmptyValues)
      .then((getResponse) => {
        setProducts(getResponse.data);
      });
  };

  const download_file = () => {
    const values = valbarcode.split('\n');
    const trimmedValues = values.map((value) => value.trim());
    const nonEmptyValues = trimmedValues.filter((value) => value !== '');
    axios
      .post('https://warehouseapi.sidehustle.id/download', nonEmptyValues, {
        responseType: 'blob',
      })
      .then((response) => {
        const currentDate = new Date();
        const year = currentDate.getFullYear().toString().slice(-2); // Mengambil 2 digit terakhir tahun
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Bulan dimulai dari 0, jadi +1, dan padStart untuk 2 digit
        const day = currentDate.getDate().toString().padStart(2, '0'); // Menggunakan padStart untuk 2 digit
        const hours = currentDate.getHours().toString().padStart(2, '0');
        const minutes = currentDate.getMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getSeconds().toString().padStart(2, '0');

        const formattedDate = `${year}${month}${day}_${hours}${minutes}${seconds}`;
        const filename = 'Stock Opname_' + String(formattedDate) + '.xlsx';

        // Handle respons saat permintaan berhasil
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        // Handle kesalahan jika permintaan gagal
        console.error(error);
      });
  };
  const updatedatabase = () => {
    setloadresponse('');
    setloadupdate(true);
    axios
      .get('https://warehouseapi.sidehustle.id/updatedatabase')
      .then((getResponse) => {
        if (getResponse.data === 'success') {
          setloadresponse('Berhasil Terupdate');
          setloadupdate(false);
        } else {
          setloadresponse('Telah terjadi error');
          setloadupdate(false);
        }
      });
  };
  return (
    <div className='App'>
      <div>
        <h1 className='text-4xl font-bold mt-10 mb-4'>
          WAREHOUSE BARCODE
          <br />
          READER
        </h1>
      </div>
      <div className='w-10/12 m-auto mb-5'>
        <div className='grid grid-cols-8 gap-5 h-full'>
          <div className='col-span-2'>
            <CompInput
              setvalbarcode={setvalbarcode}
              valbarcode={valbarcode}
              preview={preview}
              download_file={download_file}
              updatedatabase={updatedatabase}
              loadupdate={loadupdate}
              loadresponse={loadresponse}
            />
          </div>
          <div className='col-span-6'>
            <CompPrev products={products} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
